import { useQuery } from '@apollo/client'
import { Flex, Box, Heading, Button, Text } from 'rebass/styled-components'
import { TextAreaNoForm } from '../../../components/TextArea';
import { GET_ENCOUNTER_CONTENT, GET_ENCOUNTER_SUMMARY } from '../../../graphql/queries';
import { IGetEncounterAdditionalContentInput, IGetEncounterAdditionalContentOutput, IGetEncounterSummaryInput, IGetEncounterSummaryOutput } from '../../../graphql/types/queries/appointment';
import PleaseWait from '../../../components/PleaseWait';
import { Fragment } from 'react';

interface IViewFullEncounterSummaryProps {
  close: () => void
  appointmentId: string
}
function NewlineText({ text }: { text: string }) {
  return (
    <>
      {text.split('\n').map((line, index) => (
        <Fragment key={index}>
          {line}
          <br />
        </Fragment>
      ))}
    </>
  );
}

export const ViewFullEncounterSummary: React.FC<IViewFullEncounterSummaryProps> = ({ appointmentId, close }) => {
  const { data, loading, error, refetch } = useQuery<IGetEncounterSummaryOutput, IGetEncounterSummaryInput>(GET_ENCOUNTER_SUMMARY, {
    variables: {
      appointmentId
    }
  })
  // console.log({data})
  return (
    <Box style={{ margin: '0 auto', maxWidth: '90vw', maxHeight: '90vh', alignSelf: 'center', borderRadius: '20px', position: 'relative', backgroundColor: 'white', padding: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', overflow: 'hidden' }}>
      <Heading mb={4}>Additional Encounter Content3</Heading>
      <Button onClick={() => refetch()}>Refetch</Button>

      {!!loading ? (
        <PleaseWait />
      ) : (
        <Flex style={{ gap: '12px', overflowY: 'auto' }} flexDirection={'column'}>
          <Text fontSize='14px' fontWeight={500} mt={3}>Patient</Text>
          <Text paddingY={'8px'} ml={['12px']} style={{
            paddingLeft: '12px',
            borderLeft: '1px solid #344F7A99'
          }} fontWeight={300} fontSize='12px' >
            <NewlineText text={data?.healthCoachFullEncounterSummary?.Patient_name || ''} />
          </Text>

          <Text fontSize='14px' fontWeight={500} mt={3}>ICDs:</Text>
          {data?.healthCoachFullEncounterSummary?.ICD10 && data?.healthCoachFullEncounterSummary.ICD10.length > 0 ? (
            <>
              {data.healthCoachFullEncounterSummary.ICD10.map(x => {
                return (
                  <Text paddingY={'8px'} ml={['12px']} key={x} style={{
                    paddingLeft: '12px',
                    borderLeft: '1px solid #344F7A99'
                  }} fontWeight={300} fontSize='12px'>
                    {x}
                  </Text>
                )
              })}
            </>
          ) : (
            <Text paddingY={'8px'} ml={['12px']} style={{
              paddingLeft: '12px',
              opacity: 0.75,
              borderLeft: '1px solid #344F7A99'
            }} fontWeight={300} fontSize='12px' >No ICDs reported</Text>
          )}

          <Text fontSize='14px' fontWeight={500} mt={3}>Assessment</Text>
          <Text paddingY={'8px'} ml={['12px']} style={{
            paddingLeft: '12px',
            borderLeft: '1px solid #344F7A99'
          }} fontWeight={300} fontSize='12px'>
            <NewlineText text={data?.healthCoachFullEncounterSummary?.ASSESSMENT || ''} />
          </Text>


          <Text fontSize='14px' fontWeight={500} mt={3}>Objective</Text>
          <Text paddingY={'8px'} ml={['12px']} style={{
            paddingLeft: '12px',
            borderLeft: '1px solid #344F7A99'
          }} fontWeight={300} fontSize='12px' >
            <NewlineText text={data?.healthCoachFullEncounterSummary?.OBJECTIVE || ''} />
          </Text>


          <Text fontSize='14px' fontWeight={500} mt={3}>Subjective</Text>
          <Text paddingY={'8px'} ml={['12px']} style={{
            paddingLeft: '12px',
            borderLeft: '1px solid #344F7A99'
          }} fontWeight={300} fontSize='12px'>
            <NewlineText text={data?.healthCoachFullEncounterSummary?.SUBJECTIVE || ''} />
          </Text>


          <Text fontSize='14px' fontWeight={500} mt={3}>Prescription Written</Text>
          <Text paddingY={'8px'} ml={['12px']} style={{
            paddingLeft: '12px',
            borderLeft: '1px solid #344F7A99'
          }} fontWeight={300} fontSize='12px'>
            <NewlineText text={data?.healthCoachFullEncounterSummary?.PRESCRIPTION_WRITTEN || ''} />
          </Text>
        </Flex>
      )}

      <Flex flexDirection={'row'} justifyContent='space-between' width={'100%'}>
        <Button variant={'pink'} onClick={close} mt={4} >Cancel</Button>
      </Flex>
      <Box onClick={close} style={{ cursor: 'pointer', position: 'absolute', top: '-10px', right: '-10px', height: '34px', width: '34px', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#F8A294', padding: '6px', borderRadius: '50%', color: 'white' }}>
        X
      </Box>
    </Box>);
}